import { ArrowLeft } from 'lucide-react'

interface BackButtonProps {
  onClick: () => void
  label?: string
}

/**
 * "Voltar" das telas de detalhe em Ocorrências e Atendimento HUB (thread de
 * ocorrência, thread de problema, formulário de novo problema). Com borda e
 * cor pra não se perder no cabeçalho — antes era só texto cinza.
 */
export function BackButton({ onClick, label = 'Voltar' }: BackButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="inline-flex items-center gap-1.5 rounded-[5px] border border-blue-300 bg-[#eff6ff] px-2.5 py-1 text-xs font-medium text-[#1d55d6] transition hover:border-blue-400 hover:bg-blue-100 dark:border-blue-700 dark:bg-blue-900/20 dark:text-blue-300 dark:hover:bg-blue-900/40"
    >
      <ArrowLeft className="h-3.5 w-3.5" aria-hidden />
      {label}
    </button>
  )
}
